import { datadogRum } from "@datadog/browser-rum";
import styled from "styled-components";

let reported = false;

export function ErrorFallback({ resetError, error }: { resetError: () => void; error: Error }) {
  console.error(`ErrorBoundary caught an error: ${String(error)}`)

  if (!reported) {
    reported = true;
    datadogRum.addError(error, {
      source: "error-boundary",
      severity: "critical",
      error_boundary: true,
      env: process.env.NODE_ENV,
      version: process.env.REACT_APP_COMMIT_REF,
    });
  }

  const handleRetry = () => {
    resetError();
    window.location.href = '/';
  }

  return (
    <ErrorContainer>
      <ErrorMessage>
        Odottamaton virhe on tapahtunut. Virhe on raportoitu ja pyrimme korjaamaan sen mahdollisimman pian.
      </ErrorMessage>
      <ErrorDetails>{String(error)}</ErrorDetails>
      <RetryButton onClick={handleRetry}>Yritä uudelleen</RetryButton>
    </ErrorContainer>
  )
}

const ErrorContainer = styled.div`
  padding: 2rem;
  background-color: #ffe6e6;
  border: 1px solid #ff4d4d;
  border-radius: 8px;
  text-align: center;
  max-width: 500px;
  margin: 2rem auto;
  font-family: sans-serif;
  color: #333;
`

const ErrorMessage = styled.p`
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.5;
`

const ErrorDetails = styled.strong`
  display: block;
  margin: 1rem 0;
  color: #b30000;
  word-break: break-word;
`

const RetryButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #ff4d4d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;

  &:hover {
    background-color: #e60000;
  }

  &:focus {
    outline: 2px solid #b30000;
  }
`
